/**
 * Tipos de medio DB-driven (catálogo global `outlet_kinds`, gestionado por
 * superadmin). Devuelve la lista activa + mapa de labels, con fallback a los
 * labels legacy hardcodeados mientras carga o si la API falla.
 */
import { useQuery } from "@tanstack/react-query";
import { media, OUTLET_KIND_LABELS, type OutletKindOut } from "@/lib/api";

export function useOutletKinds(): {
  kinds: OutletKindOut[];
  labels: Record<string, string>;
  isLoading: boolean;
} {
  const q = useQuery({
    queryKey: ["media", "outlet-kinds"],
    queryFn: () => media.listOutletKinds({ is_active: true }),
    staleTime: 5 * 60_000,
  });

  const labels: Record<string, string> = { ...OUTLET_KIND_LABELS };
  for (const k of q.data ?? []) labels[k.code] = k.name;

  return { kinds: q.data ?? [], labels, isLoading: q.isLoading };
}
